import{f as o}from"./chunk-ASR4GGQN.js";import{m as i}from"./chunk-HBP5N4FR.js";i();var t=o,r=null;function p(e){t=e}function l(e){r=e}function a(){r!=null&&(t=r)}function c(){return t||o}function m(){return r}export{p as a,l as b,a as c,c as d,m as e};
//# sourceMappingURL=chunk-4VJH4I37.js.map
